import { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useDidMountEffect from '../../../utils/useDidMountEffect'
import { createCasinoStart, getSuperAdminGameCategoryStart, updateCasinoStart, updateSACasinoGamesStatusStart, deleteCategoryStart, getCasinoGamesCategoryCountStart } from '../../../store/redux-slices/superAdminCasinoManagement'
// deleteCategoryStart
import { useNavigate } from 'react-router-dom'
import { getLanguagesStart } from '../../../store/redux-slices/languages'

const useCategoryListing = () => {
  const dispatch = useDispatch()
  const isInitialRender = useDidMountEffect()
  const [show, setShow] = useState(false)
  const [limit, setLimit] = useState(15)
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const [statusFilter, setStatusFilter] = useState('')
  const [categoryTypeFilter, setCategoryTypeFilter] = useState("")
  const [gameCategoryId, setCasinoGameId] = useState()
  const [active, setActive] = useState('')
  const [status, setStatus] = useState()
  const [statusShow, setStatusShow] = useState(false)
  const [name, setName] = useState()
  const [data, setData] = useState()
  const [type, setType] = useState('')
  const formikRef = useRef()
  const [selectedCategory, setSelectedCategory] = useState({
    isOpen: false,
  })

  const [imageModal, setImageModal] = useState({
    isOpen: false,
    url: ""
  })

  const [deleteCategory, setDeleteCatrgory] = useState({
    isOpen: false,
    status: "",
    name: "",
    id: ""
  })

  const casinocategoryType = {
    featuredCategory: "Featured Category",
    vault: "Category Vault"
  }

  const [toggleStatus, setToggleStatus] = useState({
    isOpen: false,
    status: "",
    name: "",
    id: ""
  })


  const [selectedSubCategoryId, setSelectedCategoryId] =
    useState('')
  const { languages } = useSelector(state => state.languages)
  const [language, setLangauge] = useState('EN')
  const navigate = useNavigate()
  const [selectedProvider, setSelectedProvider] = useState('')
  const { loading, gameCategory, deleteCategoryData } = useSelector((state) => state.superAdminCasino)
  const gameList = gameCategory?.data || []
  const pagination = gameCategory?.pagination
  const totalPages = pagination?.totalPages
  const totalCount = pagination?.totalItems

  useEffect(() => {
    dispatch(getLanguagesStart({ limit: '', pageNo: '', name: '' }))
  }, [])

  // useEffect(() => {
  // dispatch(getSuperAdminGameCategoryStart({ limit, pageNo: page, search, tenantId: '', status: statusFilter, categoryType: categoryTypeFilter }))
  // }, [limit, page, statusFilter, categoryTypeFilter])


  useEffect(() => {
    if (!isInitialRender) {
      dispatch(getSuperAdminGameCategoryStart({ limit, pageNo: page, search, tenantId: '', status: statusFilter, categoryType: categoryTypeFilter }))

    }
  }, [page])

  useEffect(() => {
    setPage(1)

    dispatch(getSuperAdminGameCategoryStart({ limit, pageNo: page, search, tenantId: '', status: statusFilter, categoryType: categoryTypeFilter }))

  }, [limit, statusFilter, categoryTypeFilter])


  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialRender) {
        if (page === 1) {
          dispatch(getSuperAdminGameCategoryStart({ limit, pageNo: page, search, tenantId: '', status: statusFilter, categoryType: categoryTypeFilter }))
        } else {
          setPage(1)
        }
      }
    }, 1000)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  const navigateReorder = () => {
    navigate('/admin/casino-category/reorder')
  }
  useEffect(() => {
    if (deleteCategoryData) {
      setDeleteCatrgory({
        isOpen: false,
        id: "",
        status: "",
        name: "",
      })
      if (page === 1) {
        dispatch(getSuperAdminGameCategoryStart({ limit, pageNo: page, search, tenantId: '', status: statusFilter, categoryType: categoryTypeFilter }))
      } else {
        setPage(1)
      }
    }

  }, [deleteCategoryData])

  const onHanldeStatusConfirmation = (data) => {
    setToggleStatus({
      id: data?.gameCategoryId,
      status: data?.is_active,
      name: data?.name,
      isOpen: true
    })
  }

  const onCancleToggleStatus = () => {
    setToggleStatus({
      id: "",
      status: "",
      name: "",
      isOpen: false
    })
  }

  const onHandleCategory = (data) => {
    setSelectedCategory({
      isOpen: true,
      category: data
    })
  }


  const onHandleCategoryToggle = (data) => {
    setSelectedCategory({
      isOpen: false,
      category: ""
    })
  }



  const handleStatusShow = (id, status, myName) => {
    setCasinoGameId(id)
    setStatus(!status)
    setName(myName?.EN)
    setStatusShow(true)
  }
  const handleDeleteYes = () => {
    dispatch(deleteCategoryStart({ gameCategoryId: deleteCategory?.id }))
  }
  const handleClose = () => {
    setShow(false)
    if (formikRef?.current) {
      formikRef.current.resetForm()
    }
  }


  const handleShow = (type, data) => {
    setType(type)
    setData(data)
    setShow(true)
  }

  const handleResetFilters = () => {
    setSearch('')
    setStatusFilter('')
    setLimit(15)
    setPage(1)
    setCategoryTypeFilter("")
  }

  const handleDeleteCategory = (id, status, name) => {
    setDeleteCatrgory({
      id: id,
      status,
      name,
      isOpen: true
    })
  }

  const handleYes = () => {
    const formData = new FormData();
    formData.append('categoryType', selectedCategory?.category?.categoryData?.categoryType === "featured" ? "vault" : "featured" || '');
    //  categoryType === "featured"
    formData.append('gameCategoryId', selectedCategory?.category?.gameCategoryId || '');




    dispatch(
      updateCasinoStart({
        data: {

        },
        code: 'CASINO_CATEGORY',
        limit,
        pageNo: page,
        search,
        isformdata: true,
        formData: formData
      })
    );

    onHandleCategoryToggle();
  }

  const onToggleConfirmation = () => {

    const formData = new FormData();
    formData.append('name', toggleStatus?.name || '');
    formData.append('isActive', (!toggleStatus?.status).toString());
    formData.append('gameCategoryId', toggleStatus?.id || '');




    dispatch(
      updateCasinoStart({
        data: {
          name: toggleStatus?.name,
          isActive: !toggleStatus?.status,
          gameCategoryId: toggleStatus?.id,
        },
        code: 'CASINO_CATEGORY',
        limit,
        pageNo: page,
        search,
        isformdata: true,
        formData: formData
      })
    );

    onCancleToggleStatus();
  };


  const updateCategory = (data, { gameCategoryId }) => {
    return dispatch(
      updateCasinoStart({
        data: {
          data,
        },
        code: 'CASINO_CATEGORY',
        limit,
        pageNo: page,
        search,
        isformdata: true,
        formData: data
      }))
  }

  const createCategory = (data) =>
    dispatch(
      createCasinoStart({
        data,
        code: 'CASINO_CATEGORY',
        limit,
        pageNo: page,
        search
      })
    )

  return {
    limit,
    setLimit,
    page,
    setPage,
    loading,
    gameCategory: gameList,
    totalPages,
    search,
    setSearch,
    statusFilter,
    setStatusFilter,
    handleResetFilters,
    handleStatusShow,
    handleYes,
    handleClose,
    statusShow,
    active,
    name,
    show,
    setSelectedCategoryId,
    setSelectedProvider,
    navigate,
    setStatusShow,
    status,
    handleShow,
    data,
    type,
    createCategory,
    updateCategory,
    language,
    setLangauge,
    languages,
    handleDeleteCategory,
    deleteCategory,
    setDeleteCatrgory,
    handleDeleteYes,
    onHanldeStatusConfirmation,
    toggleStatus,
    onCancleToggleStatus,
    onToggleConfirmation,
    formikRef,
    onHandleCategory,
    setSelectedCategory,
    selectedCategory,
    casinocategoryType,
    navigateReorder,
    setImageModal,
    imageModal,
    categoryTypeFilter, setCategoryTypeFilter,
    totalCount
  }
}

export default useCategoryListing
